import React, { Component } from 'react';
import { MenuItem, Modal, Select, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import ActionButton from '../../../components/ActionButton';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: '30px',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
    width: '60%',
    maxWidth: '570px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  modalSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '20px',
  },
  modalTitle: {
    fontSize: 20,
  },
});

class ModalSelezioneModalitaAutocontrollo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipologiaItem: 'Controllo',
    };
  }
  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <div className={classes.modalSectionContainer}>
            <Typography className={classes.modalTitle}>
              Selezionare il tipo di procedura da inserire:
            </Typography>
            <Select
              style={{ marginTop: '5%' }}
              value={this.state.tipologiaItem}
              onChange={(e) => {
                this.setState({
                  tipologiaItem: e.target.value,
                });
              }}
            >
              <MenuItem value="Controllo">Controllo di conformità</MenuItem>
              <MenuItem value="Scheda">Scheda di registrazione</MenuItem>
            </Select>
            <div>
              <ActionButton
                secondaryButton
                label="Chiudi"
                onClick={this.props.onClose}
              />
              <ActionButton
                label="Conferma"
                onClick={() => {
                  this.props.handleNewRow(this.state.tipologiaItem);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneModalitaAutocontrollo.propTypes = {
  classes: PropTypes.object.isRequired,
  handleNewRow: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ModalSelezioneModalitaAutocontrollo);
